const StudyOptionContent = ({ pcn, name }) => (
  <>
    <div className="eui-filter-control-study-pcn-label">{pcn}</div>
    <div>{name}</div>
  </>
);

export { StudyOptionContent };
